<template>
  <div>
    <div class="tabs is-separatedUnderlined is-fullwidth is-marginless">
      <ul class="has-text-weight-medium">
        <li :class="{'is-active':panel === 'INFOS'}"><a @click="panel = 'INFOS'">Fiche du lot</a></li>
        <li :class="{'is-active':panel === 'DOCS'}">
          <a :class="{'disabled' : isNew}" @click="!isNew ? panel = 'DOCS' : null">Documents</a>
        </li>
        <li :class="{'is-active':panel === 'PARAMS'}">
          <a :class="{'disabled' : isNew}" @click="!isNew ? panel = 'PARAMS' : null">Paramètres</a>
        </li>
      </ul>
    </div>
    <!--<div class="has-bg-danger is-padding-left is-padding-right"
      v-if="panel === 'INFOS' && !taxDispositifsOk">
      <div class="has-text-white is-size-6">
        <span class="icon is-medium is-size-7"><i class="fas fa-star-of-life fa-xs"></i></span>
        <i>Ce lot impose de choisir un dispositif fiscal.</i>
      </div>
    </div>-->

    <div v-if="panel === 'INFOS' || fromFlux"
      class="has-bg-notification is-margin-top-xsmall is-padding-left is-padding-right">
      <div class="columns is-gapless has-text-white is-size-6">
        <div v-if="panel === 'INFOS'" class="column is-narrow is-margin-right-small">
          <span class="icon is-medium is-size-7"><i class="fas fa-check-circle fa-s"></i></span><i>Information obligatoire pour la validation du formulaire</i>
        </div>
        <div v-if="fromFlux" class="column is-narrow is-margin-right-small">
          <span class="icon is-medium is-size-7"><i class="fas fa-rss fa-s"></i></span>
          <i>Ces informations sont automatiquement mises à jour.</i>
        </div>
      </div>
    </div>

    <form @submit.prevent.stop="">
      <div v-show="panel === 'INFOS'">
        <div class="columns is-multiline has-bg-white-bis">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Informations lot<span v-if="!isNew"> {{l.ref}}</span></b>
            </div>
          </div>
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <label v-if="!refAvailable" class="label">
                  <span class="icon has-text-primary is-small has-text-danger">
                    <i class="fas fa-check-circle"></i>
                  </span>
                  <span class="">
                    <span>Référence
                      <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i>
                    </span>
                  </span>
                </label>
                <r-label v-else :label="'Référence'" :value="reference" :from-flux="fromFlux" :redCheck='true'></r-label>
                <div class="control">
                  <v-input id="ref" name="ref" @input="updateRef" :model="reference"
                          v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="Référence">
                  </v-input>
                </div>
                <p v-if="!refAvailable" class="help is-danger" data-type-cy="text" data-value-cy="error">La référence existe déjà</p>
              </div>
            </div>
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Dispositifs'" :is-required="false" :value="selectedTaxDispositifs" :from-flux="fromFlux" :redCheck="false"></r-label>
                <div class="control">
                  <multiselect v-model="selectedTaxDispositifs" :options="taxDispositifsList"
                                class="multiselect--option-ico is-single_choice"
                                :multiple="true"
                                :close-on-select="false"
                                :placeholder="''" track-by="value" label="label">
                    <span slot="placeholder" class="multiselect__placeholder">Dispositifs</span>
                    <span slot="noOptions">La liste est vide</span>
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="columns column is-paddingless is-12">
              <div class="column is-4">
                <label class="label">Prix immo HT
                </label>
                <!-- <r-label :label="'Prix immo HT'" :value="sale_price_ht" :from-flux="fromFlux"></r-label> -->
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <v-input id="sale_price_ht" name="sale_price_ht" @input="val => sale_price_ht = val" :model="sale_price_ht"
                             input-type="number"
                             v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                             :number="true"
                             data-vv-as="Prix immo HT">
                    </v-input>
                  </div>
                  <div class="control">
                    <a class="button is-static is-border is-min-width-0">
                      <span class="icon is-small" :class="`is-currency-${$faCurrency}`"><i :class="`fas fa-${$faCurrency}-sign`"></i></span><span>HT</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-2">
                <div v-if="sale_price_ht && sale_price">
                  <label class="label" for="tva">TVA</label>
                  <div class="has-text-weight-bold has-text-black is-size-4">
                    {{sale_price_ht | tva(sale_price) | prettyPrice}} %
                  </div>
                  <div class="has-text-weight-light has-text-black is-size-6">
                    {{sale_price - sale_price_ht | prettyPrice}} {{$currency}}
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <r-label :label="'Prix immo TTC'" :value="sale_price" :from-flux="fromFlux" :redCheck='true'></r-label>
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <v-input id="sale_price" name="sale_price" @input="val => sale_price = val" :model="sale_price"
                             input-type="number"
                             v-validate="'required|decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                             :number="true"
                             data-vv-as="Prix immo TTC">
                    </v-input>
                  </div>
                  <div class="control">
                    <a class="button is-static is-border is-min-width-0">
                      <span class="icon is-small" :class="`is-currency-${$faCurrency}`"><i :class="`fas fa-${$faCurrency}-sign`"></i></span><span>TTC</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns column is-paddingless is-12">
              <div class="column is-6 is-padding-left is-padding-right is-paddingless-top">
                <label class="label">Loyer marché
                </label>
                <!-- <r-label :label="'Loyer marché'" :value="rent" :from-flux="fromFlux" :redCheck='false'></r-label> -->
                <div class="field has-addons">
                  <div class="control">
                    <v-input id="rent" name="rent" @input="val => rent = val" :model="rent"
                            input-type="number" :number="true"
                            :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Loyer HC"
                            class="">
                    </v-input>
                  </div>
                  <div class="control">
                    <a class="button is-square is-static is-border is-min-width-0">
                      <span class="icon is-small" :class="`is-currency-${$faCurrency}`"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-6 is-paddingless-top">
                <div class="field">
                  <label class="label">Rentabilité marché
                    <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i>
                  </label>
                  <div class="columns is-gapless">
                    <div class="field has-addons">
                      <div class="control">
                        <input id="profitability" name="profitability" v-model.number="profitability"
                                type="number" :number="true" :disabled="true" class="input is-border">
                      </div>
                      <div class="control">
                        <a class="button is-square is-static is-border is-min-width-0">
                          <span class="icon"><i class="fas fa-percentage"></i></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns column is-paddingless is-12">
              <div class="column is-4 is-paddingless-top">
                <r-label :label="'Prix immo (hors parking) HT'" :is-required="false" :value="sale_price_less_parking_ht"></r-label>
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <v-input id="sale_price_less_parking_ht" name="sale_price_less_parking_ht"
                             @input="val => sale_price_less_parking_ht = val"
                             :model="sale_price_less_parking_ht" :number="true" input-type="number"
                             v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                             data-vv-as="Prix immo (hors parking) HT">
                    </v-input>
                  </div>
                  <div class="control">
                    <a class="button is-static is-border is-min-width-0">
                      <span class="icon is-small" :class="`is-currency-${$faCurrency}`"><i :class="`fas fa-${$faCurrency}-sign`"></i></span><span>HT</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-2 is-paddingless-top">
                <div v-if="sale_price_less_parking_ht && sale_price_less_parking">
                  <label class="label" for="tva">TVA</label>
                  <div class="has-text-weight-bold has-text-black is-size-4">
                    {{sale_price_less_parking_ht | tva(sale_price_less_parking) | prettyPrice}} %
                  </div>
                  <div class="has-text-weight-light has-text-black is-size-6">
                    {{sale_price_less_parking - sale_price_less_parking_ht | prettyPrice}} {{$currency}}
                  </div>
                </div>
              </div>
              <div class="column is-4 is-paddingless-top">
                <r-label :label="'Prix immo (hors parking) TTC'" :is-required="false" :value="sale_price_less_parking"></r-label>
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <v-input id="sale_price_less_parking" name="sale_price_less_parking"
                             @input="val => sale_price_less_parking = val"
                             :model="sale_price_less_parking" input-type="number"
                             v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val" :number="true"
                             data-vv-as="Prix immo (hors parking) TTC">
                    </v-input>
                  </div>
                  <div class="control">
                    <a class="button is-static is-border is-min-width-0">
                      <span class="icon is-small" :class="`is-currency-${$faCurrency}`"><i :class="`fas fa-${$faCurrency}-sign`"></i></span><span>TTC</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns column is-paddingless is-12">
              <div class="column is-6 is-padding-left is-padding-right is-paddingless-top">
                <label class="label" for="cappedRent">
                  Loyer Plafonné
                </label>
                <div class="field has-addons">
                  <div class="control">
                    <v-input id="cappedRent" name="cappedRent" @input="val => cappedRent = val" :model="cappedRent"
                             input-type="number" :number="true"
                             v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                             data-vv-as="Loyer HC"
                             :disabled="!sale_price_less_parking && !sale_price_less_parking_ht"
                             :classes="(!sale_price_less_parking && !sale_price_less_parking_ht) ? 'is-border' : ''">
                    </v-input>
                  </div>
                  <div class="control">
                    <a class="button is-square is-static is-border is-min-width-0" :class="`is-currency-${$faCurrency}`">
                      <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-6 is-paddingless-top">
                <div class="field">
                  <label class="label" for="cappedProfitability">
                    Rentabilité Plafonnée
                  </label>
                  <div class="columns is-gapless">
                    <div class="field has-addons">
                      <div class="control is-expanded">
                        <input id="cappedProfitability" name="cappedProfitability" v-model.number="cappedProfitability"
                               type="number" :number="true" :disabled="true" class="input is-border">
                      </div>
                      <div class="control">
                        <a class="button is-square is-static is-border is-min-width-0">
                          <span class="icon"><i class="fas fa-percentage"></i></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Prix Packagé -->
          <template v-for="(newPrice, i) in newPriceArray">
            <lot-prix-package :newPrice="newPrice" :key="i" :idx="i" :isSubmited="isSubmited" @removeNewPrice="removeNewPrice"></lot-prix-package>
          </template>
          <div class="column is-gapless is-12 columns is-multiline is-border-top">
            <a @click="addNewPrice" class="button is-primary is-transform-none">Ajouter un prix packagé</a>
          </div>
        </div>
        <div class="columns is-multiline has-bg-light is-border-top">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Caractéristiques du lot</b>
            </div>
          </div>
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Nature'" :redCheck='true' :from-flux='fromFlux' :value="nature"></r-label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="nature">
                      <option :value="null">Selectionnez une nature</option>
                      <option v-for="c in filteredNaturesList" :value="c.value" :key="c.value">{{c.label}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="nature !== 'field'" class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Typologie'" :is-required="hasCheck" :redCheck='hasCheck' :from-flux='fromFlux' :value="lot_type"></r-label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="lot_type">
                      <option :value="null">Selectionnez un type</option>
                      <option v-for="c in typesList" :value="c.value" :key="c.value">{{c.label}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="nature !== 'field'" class="column is-3 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Étage'" :is-required="hasCheck" :redCheck='hasCheck' :value="floor"></r-label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="floor">
                      <option :value="null">Selectionnez l'étage du lot</option>
                      <option v-for="c in floorsList" :value="c.value" :key="c.value">{{c.label}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <r-label :label="'Surface en m2'" :value="surface" :redCheck='true' :from-flux="fromFlux"></r-label>
                <div class="control">
                  <v-input id="surface" name="surface" @input="val => surface = val" :model="surface"
                          input-type="number" :number="true"
                          v-validate="'required|decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                          data-vv-as="Surface">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-12 is-padding">
              <label class="label" for="surface">Orientation <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i></label>
              <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                <div class="column is-3 has-bg-white" v-for="e in exposureList" :key="'exposure-'+e.value">
                  <input v-model="l.exposures" :value="e.value"
                        :name="'exposures'" :id="'exposure-'+e.value" type="checkbox" class="checkradiocase is-fullwidth">
                  <label :for="'exposure-'+e.value">{{e.label}}</label>
                </div>
              </div>
            </div>
            <div class="column is-12 is-padding">
              <label class="label" data-type-cy="text" data-value-cy="input_desc_label">Description du lot</label>
                <div class="field" @mouseover="displayToolbar = true" @mouseleave="displayToolbar = false">
                  <div class="control">
                    <wysiwyg-editor :model="lot.description" placeholder="" :id="'descText'" :name="'descText'"
                                    @change="val => lot.description = val"
                                    :class="{'editr--hide-toolbar':!displayToolbar}"
                                    class="editr--bottom-toolbar editr--height-medium content has-bg-white"
                                    data-type-cy="wysiwyg-editor" :data-value-cy="'input_desc'"/>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline is-border-top">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Annexes</b>
            </div>
          </div>
          <div class="column columns is-multiline is-paddingless-left is-paddingless-right is-paddingless-bottom">
            <div class="column is-12 is-paddingless">
              <div v-if="!validAnnexes" class="notification is-padding-small is-warning">
                <span class="icon is-margin-left"><i class="fa-lg fas fa-engine-warning is-margin-right"></i></span>
                Une annexe doit impérativement avoir un type défini.<br>
              </div>
            </div>
            <annexe-item class="column columns is-12 is-padding-bottom-xsmall is-multiline"
                 v-for="(a, i) in annexes" :key="i"
                 :source="a" :fromFlux="fromFlux"
                 @remove="removeAnnexe"></annexe-item>
            <div class="column is-paddingless-top is-paddingless-left is-12 has-text-right">
              <a @click="addNewAnnexe" class="button is-white is-border is-rounded is-transform-none is-padding-right-large is-padding-left-large">
                &nbsp;<span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span><span>Ajouter une annexe</span></a>
            </div>
          </div>
        </div>
        <div class="columns is-multiline is-marginless-top is-border-top">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Parking/Box/Garage</b>
            </div>
          </div>
          <div class="column columns is-multiline is-paddingless-left is-paddingless-right is-paddingless-bottom">
            <div class="column is-12 is-paddingless">
              <div v-if="!validParkings" class="notification is-padding-small is-warning columns is-vcentered">
                <div><span class="icon is-margin-left"><i class="fa-lg fas fa-engine-warning is-margin-right"></i></span></div>
                <div>
                  Vous devez obligatoirement déclarer une caractéristique pour chaque parking.<br>
                  Elle peuvent être identiques, auquel cas utilisez le même tag de qualification.<br>
                </div>
              </div>
            </div>
            <parking-item class="column columns is-12 is-padding-bottom-xsmall is-multiline"
                 v-for="(p, i) in parkings" :key="i"
                 :source="p" :fromFlux="fromFlux"
                 :default-parking-type="defaultParkingType"
                 @updateAnnexType="val => defaultParkingType.push(val)"
                 @remove="removeParking"></parking-item>
            <div class="column is-paddingless-top is-paddingless-left is-12 has-text-right">
              <a @click="addNewParking" class="button is-white is-border is-rounded is-transform-none is-padding-right-large is-padding-left-large">
                &nbsp;<span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span><span>Ajouter un parking</span></a>
            </div>
          </div>
        </div>
      </div>
      <div v-show="panel === 'DOCS'">
        <div class="columns is-multiline has-bg-light">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Plan du lot</b>
              <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                <i class="fal fa-info-circle"></i>
              </span>
            </div>
          </div>
          <div class="column is-12">
            <div v-if="!fromFlux">
              <upload-file @upload="uploadPlan"
                           :custom-id="'plan'"
                           @deleteDocuments="deletePlanDuLot"
                           :documents="compact([plan])"
                           :unique="true"
                           :canDrag="false"></upload-file>
            </div>
            <div v-else>
              <view-file-list :documents="compact([plan])" :fromFlux="true" v-if="plan" :canDrag='false' :isArray="true"></view-file-list>
              <div v-else>Le promoteur ne fournit pas de plan pour ce lot.</div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Documents</b>
              <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                <i class="fal fa-info-circle"></i>
              </span>
            </div>
          </div>
          <div class="column is-12">
            <div>
              <label class="label">Téléchargez des documents</label>
              <upload-file @upload="uploadDocument"
                            @deleteDocuments='deleteDocuments'
                           :custom-id="'documents'"
                           :placeholder="'Sélectionner document(s)'"
                           :documents="documents"></upload-file>
            </div>
          </div>
        </div>
        <div class="columns is-multiline has-bg-light" v-if="program && program.from_flux">
          <div class="column is-12 is-paddingless-bottom">
            <div class="title is-5">
              <b class="is-uppercase">Documents issus du flux promoteur</b>
              <span class="is-padding-left-xsmall" v-helper.bottom="'48pvPnXWhfMnF10pIqZ4tj'">
                <i class="fal fa-info-circle"></i>
              </span>
            </div>
          </div>
          <div class="column is-12">
            <div v-if="documentsFlux && documentsFlux.length">
              <view-file-list :documents="documentsFlux" :fromFlux="true" :isArray="true"></view-file-list>
            </div>
            <div v-else>
              <div>Le promoteur ne fournit pas de document.</div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="panel === 'PARAMS'">
        <div v-if="showStatusSelect" class="columns is-multiline">
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-12 is-padding-left is-padding-right is-padding-top">
              <label class="label" for="tags">Statut d'édition du lot</label>
              <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                <div class="column is-3 has-bg-white" v-for="s in availableLotStatusList" :key="'status-'+s.value">
                  <input v-model="lotStatus" :value="s.value" :disabled="!isAdmin"
                        :name="'statusLot'" :id="'status-'+s.value" type="radio" class="checkradiocase is-fullwidth">
                  <label :for="'status-'+s.value">{{s.label}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline is-padding-bottom">
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-6 is-padding-left is-padding-right is-padding-top">
              <div class="field">
                <label class="label" for="tags">Tags (20 caractères max, 4 tags maxs)</label>
                <div class="control">
                  <tag-input @tagChange="tagChange" :tag="l.tags"
                              v-model="l.tags"
                              :placeholder="'Appuyez sur Entrée pour valider'"></tag-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="formActionsSticky is-bottom is-margin-top">
        <div v-show="!canSubmit"
          class="is-padding-xsmall has-bg-danger has-text-white has-text-centered is-size-7">
          <i>Ce formulaire comporte une ou plusieurs information(s) manquantes ou mal renseignées</i>
        </div>
        <div class=" columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
          <div class="column is-4 is-3-widescreen is-margin-right-small">
            <a @click="$router.goBack(route)" class="button is-light is-uppercase is-fullwidth">
              <span>Annuler</span>
            </a>
          </div>
          <div class="column is-4 is-3-widescreen is-margin-left-small">
            <button class="button is-success is-uppercase is-fullwidth has-text-white"
                  :disabled="!canSubmit || loading" @click="beforeSubmit"
                  :class="{'is-loading':loading}">
              <span v-if="!loading">Valider</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { debounce, isEmpty, compact } from 'lodash'
  import { mapGetters } from 'vuex'
  import { DefaultValues } from '../../mixins'
  import AnnexeItem from './AnnexeItem'
  import ParkingItem from './ParkingItem'
  import LotPrixPackage from './LotPrixPackage'

  const emptyLot = {
    ref: null,
    tax_dispositifs: [],
    annexes: [],
    lot_type: null,
    status: 'draft',
    surface: null,
    rent: null,
    sale_price: null,
    sale_price_ht: null,
    exposures: [],
    nature: null,
    floor: null,
    profitability: null,
    description: null
  }

  const emptyAnnex = {
    annex_type: null,
    surface: null,
    info: null,
    is_parking: false
  }
  const emptyNewPrice = {
    name: null,
    description: null,
    sale_price: null,
    sale_price_ht: null
  }

  export default {
    name: 'LotForm',
    mixins: [DefaultValues],
    components: {AnnexeItem, ParkingItem, LotPrixPackage},
    props: {
      edit: {
        type: Boolean,
        default: false
      },
      source: {
        required: false
      },
      program: {
        required: true
      },
      loading: {
        required: false
      },
      selectPanel: {
        type: String,
        default: 'INFOS'
      }
    },
    data () {
      return {
        displayToolbar: false,
        reference: null,
        nature: null,
        lot_type: null,
        floor: null,
        hasCheck: false,
        isSubmited: false,
        lot: {},
        plan: null,
        panel: 'INFOS',
        route: this.$route,
        refAvailable: true,
        isNew: true,
        lotStatus: null,
        uploading: false,
        documents: [],
        selectedTaxDispositifs: [],
        annexesArray: [],
        defaultParkingType: [],
        exposures: [],
        surface: null,
        rent: null,
        cappedRent: null,
        sale_price: null,
        sale_price_ht: null,
        sale_price_less_parking: null,
        sale_price_less_parking_ht: null,
        newPriceArray: [],
        compact
      }
    },
    //  watch: {
    //   reference: function (val) {
    //     console.log(val)
    //     this.updateRef(val)
    //   }
    // },
    computed: {
      ...mapGetters(['isExternal', 'isAdmin', 'isManager']),
      showStatusSelect () {
        if (!this.source) return
        if ('status' in this.source) {
          return ['draft', 'available'].includes(this.source.status)
        }
      },
      filteredNaturesList () {
        return this.naturesList.filter(x => !x.hide)
      },
      availableLotStatus () {
        return [
          this.statusData.draft,
          this.statusData.available
        ]
      },
      availableLotStatusList () {
        return Object.values(this.availableLotStatus).filter(x => !x.hide)
      },
      validAnnexes () {
        let isValid = true
        this.annexesArray.forEach(x => {
          if (!x.annex_type && !x.is_parking) {
            isValid = false
          }
        })
        return isValid
      },
      validParkings () {
        let isValid = true
        this.annexesArray.forEach(x => {
          if (x.is_parking && !x.annex_type) {
            isValid = false
          }
        })
        return isValid
      },
      l () {
        return this.lot
      },
      taxDispositifsOk () {
        return !(this.program.tax_dispositifs && this.program.tax_dispositifs.length > 0 && this.selectedTaxDispositifs.length === 0)
      },
      availableDispositifs () {
        if (this.taxDispositifsData) {
          return compact(this.program.tax_dispositifs.map(x => {
            if (x in this.taxDispositifsData) return this.taxDispositifsData[x]
          }))
        }
      },
      canSubmit () {
        return this.refAvailable && this.validAnnexes && this.validParkings && this.nature && this.sale_price && this.surface
      },
      annexes () {
        if (this.annexesArray && this.annexesArray.length) {
          let annexes = this.annexesArray.map((x, i) => {
            x.index = i
            return x
          }).filter(x => !x.is_parking)
          return annexes
        } else return []
      },
      parkings () {
        if (this.annexesArray && this.annexesArray.length) {
          let parkings = this.annexesArray.map((x, i) => {
            x.index = i
            return x
          }).filter(x => x.is_parking)
          return parkings
        } else return []
      },
      fromFlux () {
        if (this.program && this.program.from_flux) {
          return this.program.from_flux
        } else return false
      },
      documentsFlux () {
        if (this.lot && this.lot.documents_flux && this.lot.documents_flux.length > 0) {
          return this.lot.documents_flux
        } else return []
      },
      cappedProfitability () {
        if (this.cappedRent !== this.l.capped_rent || this.sale_price_less_parking !== this.l.sale_price_less_parking) {
          return (this.cappedRent * 12 / this.sale_price_less_parking * 100).toFixed(2)
        } else return this.l.capped_profitability
      },
      profitability () {
        if (this.rent !== this.l.rent || this.sale_price !== this.l.sale_price) {
          return (this.rent * 12 / this.sale_price * 100).toFixed(2)
        } else return this.l.profitability
      }
    },
    methods: {
      deleteDocuments (document) {
        let idx = this.documents.findIndex(x => x.filename === document.filename)
        this.documents.splice(idx, 1)
      },
      deletePlanDuLot (document) {
        this.plan = null
      },
      addNewAnnexe () {
        this.annexesArray.push(Object.assign({}, emptyAnnex))
      },
      addNewParking () {
        this.annexesArray.push(Object.assign({}, emptyAnnex, {is_parking: true}))
      },
      removeAnnexe (index) {
        this.annexesArray.splice(index, 1)
      },
      removeParking (index) {
        this.annexesArray.splice(index, 1)
      },
      addNewPrice () {
        this.newPriceArray.push(Object.assign({}, emptyNewPrice))
      },
      removeNewPrice (index) {
        this.newPriceArray.splice(index, 1)
      },
      beforeSubmit () {
        this.newPriceArray.forEach((x, idx) => {
          if ((x.sale_price_ht === '' || x.sale_price_ht === null) && (x.name === '' || x.name === null) && (x.sale_price === '' || x.sale_price === null) && (x.description === '' || x.description === null)) {
            this.removeNewPrice(idx)
          }
        })
        this.submit()
      },
      submit () {
        this.isSubmited = true
        if (!this.nature) {
          this.$notify({
            type: 'is-danger',
            text: 'Le formulaire est invalide.'
          })
          return
        }
        this.validate((valid) => {
          if (valid) {
            if (this.loading) return
            if (this.selectedTaxDispositifs && this.selectedTaxDispositifs.length) {
              this.lot.tax_dispositifs = this.selectedTaxDispositifs.map(x => x.value || x)
            }
            this.lot.nature = this.nature
            this.lot.floor = this.floor
            this.lot.lot_type = this.lot_type
            this.lot.annexes = this.annexes.concat(this.parkings)
            this.lot.surface = this.surface
            this.lot.sale_price = this.sale_price
            this.lot.sale_price_ht = this.sale_price_ht
            if (this.sale_price_less_parking && this.sale_price_less_parking !== '') {
              this.lot.sale_price_less_parking = this.sale_price_less_parking
            } else {
              this.lot.sale_price_less_parking = null
            }
            if (this.sale_price_less_parking_ht && this.sale_price_less_parking_ht !== '') {
              this.lot.sale_price_less_parking_ht = this.sale_price_less_parking_ht
            } else {
              this.lot.sale_price_less_parking_ht = null
            }
            // this.lot.profitability = this.profitability
            this.lot.custom_prices = this.newPriceArray
            if (this.rent && this.rent !== '') {
              this.lot.rent = this.rent
            } else {
              this.lot.rent = null
            }
            if (this.cappedRent && this.cappedRent !== '') {
              this.lot.capped_rent = this.cappedRent
            } else {
              this.lot.capped_rent = null
            }

            this.lot.documents = this.documents
            this.lot.status = this.lotStatus

            if (this.plan && !isEmpty(this.plan)) {
              this.lot.plan = [this.plan]
            } else this.lot.plan = null

            this.$emit('submit', this.lot)
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Le formulaire est invalide.'
            })
          }
        })
      },
      // updateRefBefore (val) {
      //   this.reference = val
      //   this.updateRef(val)
      // },
      updateRef: debounce(function (val) {
        console.log(val)
        this.reference = val
        let previousVal = this.lot.ref
        this.lot.ref = val
        if (this.lot.ref !== previousVal && val.length >= 2) {
          this.$api.lotService.get({ref: val, program: this.program.pk}).then(r => {
            if ((r.data.items.length === 1 && r.data.items[0].pk === this.lot.pk) || r.data.items.length === 0) {
              this.refAvailable = true
            } else {
              this.refAvailable = false
              this.$notify({
                type: 'is-danger',
                text: 'La référence existe déjà.'
              })
            }
          })
        }
      }, 700),
      uploadDocument (e) {
        if (e.cropped) this.documents.splice(e.croppedIndex, 1, e[0])
        else e.map(el => this.documents.push(el))

        this.$set(this.lot, 'documents', this.documents)
      },
      uploadPlan (e) {
        if (e && e.length) {
          this.$set(this, 'plan', e[0])
        } else {
          this.$set(this, 'plan', null)
        }
      },
      validate (cb) {
        this.$validator.validateAll().then((result) => {
          cb(result)
        })
      },
      checkRef (lotRef) {
        this.$api.lotService.get({ref: lotRef, program: this.program.pk})
      },
      tagChange (newTags) {
        this.$set(this.l, 'tags', newTags)
      },
      getAnnexType (query) {
        this.$api.annexTypeService.get(query).then(r => {
          this.defaultParkingType = r.data.map(x => x.name)
        })
      },
      hasError (name) {
        return this.errors.has(name)
      }
    },
    created () {
      this.isSubmited = false
      this.lot.program = this.program
      if (this.source) {
        this.isNew = false
        this.lot = Object.assign(this.lot, this.source)
        if (!this.edit) {
          this.lot.ref = null
          this.reference = null
          this.lot.pk = null
          this.lotStatus = 'draft'
          this.lot.plan = []
          this.lot.documents = []
          if ('nature' in this.source && this.source.nature) {
            this.nature = this.source.nature
          }
          if ('surface' in this.source && this.source.surface) {
            this.surface = this.source.surface
          }
          if ('floor' in this.source && this.source.floor) {
            this.floor = this.source.floor
          }
          if ('lot_type' in this.source && this.source.lot_type) {
            this.lot_type = this.source.lot_type
          }
        } else {
          this.floor = this.source.floor
          this.lot_type = this.source.lot_type
          this.reference = this.source.ref
          this.nature = this.source.nature
          this.surface = this.source.surface
          this.lotStatus = this.source.status
          this.documents = this.source.documents
          if (this.lot.plan) {
            this.plan = this.lot.plan
          }
        }
        this.annexesArray = this.source.annexes
        this.newPriceArray = this.source.custom_prices || []

        if (!Array.isArray(this.lot.tax_dispositifs) && !this.lot.tax_dispositifs.length) {
          this.selectedTaxDispositifs = []
        } else if (!Array.isArray(this.lot.tax_dispositifs) && this.lot.tax_dispositifs.length) {
          this.selectedTaxDispositifs = [this.taxDispositifsData[this.lot.tax_dispositifs]]
        } else if (Array.isArray(this.lot.tax_dispositifs) && this.lot.tax_dispositifs.length && this.taxDispositifsData) {
          this.selectedTaxDispositifs = compact(this.lot.tax_dispositifs.map(x => {
            if (x in this.taxDispositifsData) return this.taxDispositifsData[x]
          }))
        }
        this.sale_price = this.lot.sale_price
        this.sale_price_ht = this.lot.sale_price_ht
        this.sale_price_less_parking = this.lot.sale_price_less_parking
        this.sale_price_less_parking_ht = this.lot.sale_price_less_parking_ht

        this.rent = this.lot.rent
        this.cappedRent = this.lot.capped_rent
      } else {
        this.lot = Object.assign(this.lot, emptyLot)
        this.lotStatus = 'draft'
        this.plan = null
        this.documents = []
      }
      if (this.selectPanel) {
        this.panel = this.selectPanel
      }
      if ('check' in this.$route.query) {
        this.hasCheck = true
      }
      this.getAnnexType()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/LotForm.vue